import { Button, ModalDialog, ActionRow } from '@openedx/paragon';
import { useEffect, useRef, useState } from 'react';
import Cookies from 'universal-cookie';
import { toast } from 'react-toastify';
// @ts-ignore
import { getConfig } from '@edx/frontend-platform/config';

import { EDX_LOGIN_COOKIE } from '../config';

const CookiePollLogout = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const prevLoggedIn = useRef(false);

  useEffect(() => {
    const timer = setInterval(() => {
      const cookies = new Cookies();
      const isLoggedIn = cookies.get(EDX_LOGIN_COOKIE);

      const isSessionExpired = prevLoggedIn.current && !isLoggedIn && !isDialogOpen;
      const isSessionRenewed = !prevLoggedIn.current && isLoggedIn && isDialogOpen;
      const updateSession = !prevLoggedIn.current && isLoggedIn && !isDialogOpen;

      if (isSessionExpired) {
        setIsDialogOpen(true);
        prevLoggedIn.current = false;
        toast.warning('Session has expired');
      } else if (isSessionRenewed) {
        setIsDialogOpen(false);
        prevLoggedIn.current = true;
        toast.success('Session has updated');
        window.setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else if (updateSession) {
        prevLoggedIn.current = true;
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [isDialogOpen]);

  return (
    <ModalDialog
      isOpen={isDialogOpen}
      size="md"
      hasCloseButton={false}
      title="Session Expired"
      zIndex={1}
      isFullscreenScroll
      isBlocking
      onClose={() => {}}
    >
      <ModalDialog.Header>
        <p>Your session has expired.</p>
      </ModalDialog.Header>

      <ModalDialog.Footer>
        <ActionRow>
          <Button as="a" href={getConfig().LOGIN_URL}>Login</Button>
        </ActionRow>
      </ModalDialog.Footer>
    </ModalDialog>
  );
};

export default CookiePollLogout;
